(function() {

	var trackingData = $(document.body).attr("data-track");

	window.trackFbEvent = function(event, data) {
		if (typeof fbq !== "undefined") {
			fbq('track', event, data);	
		}
	}

	if (trackingData) {
		trackingData = JSON.parse(trackingData);

		var facebookData = trackingData["fb"];

		if (facebookData) {
			var event = facebookData.event;
			var data  = facebookData.data || null;

			trackFbEvent(event, data);
		}
	}

	CartItems.on("add", function(item) {
		var data = {
			value: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
			currency: "EUR",
			content_ids: [ item.id ],
			contents: [{
				id: item.id,
				quantity: 1,
				item_price: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price
			}],
			content_type: "product",
			content_name: item.title,
			content_category: item.category.name
		};

		trackFbEvent("AddToCart", data);
	});

	let trackImpressions = function(parent, lists) {

		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let listName = '';
		let listId = '';

		if (!lists) {
			if (parent) {
				lists = $(parent).find("[data-product-list]");
			} else {
				lists = $("[data-product-list]");
			}
		} else {
			listName = $(parent).attr("data-product-list");
			listId = $(parent).attr("data-product-list-id");
		}

		lists.each(function (ind, list) {
			
			let $list = $(list);

			if ($list.attr("data-product-list") && $list.attr("data-product-list-id")) {
				listName = $list.attr("data-product-list");
				listId = $list.attr("data-product-list-id");
			}

			let products = [];

			$list.find("[data-ga]").each(function() {

				let itemProps = $(this).attr("data-ga");

				if (itemProps) {
					itemProps = JSON.parse(itemProps);

					products.push({
						item_id: itemProps.id,
						item_name: itemProps.name,
						currency: "BGN",
						discount: parseFloat(itemProps.discount),
						index: itemProps.position,
						item_brand: itemProps.brand,
						item_category: itemProps.category,
						price: parseFloat(itemProps.base_price),
						quantity: 1
					}); 
				}
			});

			// Clear the previous ecommerce object.
			dataLayer.push({ ecommerce: null });
			// Push data layer event
			dataLayer.push({
				event: "view_item_list", 
				ecommerce: {
					item_list_id: listId,
					item_list_name: listName,
					items: products
				}
			});
		});

	}

	let trackDetail = function() {

		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let $product = $("[data-product-detail]");
		let data     = $product.attr("data-ga");

		if (data) {
			data = JSON.parse(data);

			// Clear the previous ecommerce object.
			dataLayer.push({ ecommerce: null });
			// Push data layer event
			dataLayer.push({
				event: 'view_item', 
				ecommerce: {
					currency: "BGN",
					value: parseFloat(data.price),
					items: [
					{
						item_id: data.id,
						item_name: data.name,
						discount: parseFloat(data.discount),
						item_brand: data.brand,
						item_category: data.category,
						price: parseFloat(data.base_price),
						quantity: 1,
						id: data.id,
					}
					]
				}
			});
		}

	}

	let trackProductAdd = function(item) {

		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });

		// Push data layer event
		dataLayer.push({
			event: 'add_to_cart', 
			ecommerce: {
				currency: "BGN",
				value: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
				items: [
				{
					item_id: item.id,
					item_name: item.title,
					discount: parseFloat(item.price - item.promo_price),
					item_brand: "by Mikka",
					item_category: item.category.name,
					price: parseFloat(item.price),
					quantity: 1,
				}
				]
			}
		});
	}

	let trackProductRemove = function(item) {
		
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: 'remove_from_cart',
			ecommerce: {
				currency: "BGN",
				value: item.promo_price && item.promo_price < item.price ? item.promo_price : item.price,
				items: [
				{
					item_id: item.id,
					item_name: item.title,
					discount: parseFloat(item.price - item.promo_price),
					item_brand: "by Mikka",
					item_category: item.category.name,
					price: parseFloat(item.price),
					quantity: 1
				}
				]
			}
		});
	}

	let trackCheckoutProcess = function() {
		
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}
	
		let data = $(document.body).attr("data-track");

		if (data) {
			data = JSON.parse(data);

			// No ga data
			if (!data.ga) {
				return;
			}

			if (data.ga.event == "Checkout") {
				trackCheckout(data.ga);
			}

			if (data.ga.event == "Purchase") {
				trackPurchase(data.ga);
			}
		}

	}

	let trackCheckout = function(data) {
		
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		let total = 0;

		data.items.forEach(item => {
			total += parseFloat(item.price) - parseFloat(item.discount);
		});

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: "begin_checkout", 
			ecommerce: {
				currency: "BGN",
				value: total,
				items: data.items
			}
		});
	}

	let trackPurchase = function(data) {

		// Do nothing if ga is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}

		var items = data.items;
		var revenue = 0;

		for (var i = 0, len = items.length; i < len; i++) {
			revenue += parseFloat(items[i].price, 10);
		}
		
		var commissions = items.map(function(item) {
			return {
				sub_amount: item.price,
				commission_type: item.category_id
			};
		})

		tap('conversionMulti', 
			data.id, 
			{
				program_group: 'mikka-494'
			},
			commissions
		);

		if (data.shipping) {
			revenue += parseFloat(data.shipping, 10);
		}

		// Clear the previous ecommerce object.
		dataLayer.push({ ecommerce: null });
		// Push data layer event
		dataLayer.push({
			event: "purchase", 
			ecommerce: {
				transaction_id: data.id,
				value         : revenue,
				shipping      : data.shipping,
				currency      : "BGN",
				coupon        : data.coupon,
				items         : data.items
			}
		});
	}

	// window.trackPurchase = function(data) {
	// 	// Do nothing if ga is not loaded
	// 	if (typeof ga === "undefined") {
	// 		return;
	// 	}

	// 	var items = data.items;
	// 	var revenue = 0;

	// 	for (var i = 0, len = items.length; i < len; i++) {
	// 		ga("ec:addProduct", items[i]);

	// 		revenue += parseFloat(items[i].price, 10);
	// 	}
		
	// 	var commissions = items.map(function(item) {
	// 		return {
	// 			sub_amount: item.price,
	// 			commission_type: item.category_id
	// 		};
	// 	})

	// 	tap('conversionMulti', 
	// 		data.id, 
	// 		{
	// 			program_group: 'mikka-494'
	// 		},
	// 		commissions
	// 	);

	// 	if (data.shipping) {
	// 		revenue += parseFloat(data.shipping, 10);
	// 	}

	// 	ga("ec:setAction", "purchase", {
	// 		"id": data.id,
	// 		"revenue": revenue,
	// 		"shipping": data.shipping
	// 	});

	// }

	var trackSearch = function(term) {
		// Do nothing if dataLayer is not loaded
		if (typeof dataLayer === "undefined") {
			return;
		}
		
		// ga('send', 'pageview', '/search?term=' + term)
	}

	// var trackEcommerceHit = function() {
	// 	// Do nothing if ga is not loaded
	// 	if (typeof ga === "undefined") {
	// 		return;
	// 	}

	// 	ga("send", {
	// 		hitType: 'event',
	// 		eventCategory: 'Ecommerce',
	// 		eventAction: 'HIT',
	// 		nonInteraction: true
	// 	});
	// }

	window.ECMT = {
		
		beforePageView: function() {
			trackDetail();
			trackImpressions();
			trackCheckoutProcess();

			CartItems.on("add", trackProductAdd);
			CartItems.on("remove", trackProductRemove);

		},

		trackImpressions: function(parent, lists) {
			trackImpressions(parent, lists);
		},

		trackSearch: function(term) {
			trackSearch(term);
		}

	}

})();